import * as React from "react";
import Svg, { Path } from "react-native-svg";

const UserIcon = (props) => (
  <Svg
    width={22}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M18.444 16.405a8.034 8.034 0 0 0-1.731-2.567 8.07 8.07 0 0 0-2.568-1.732l-.025-.01A5.327 5.327 0 0 0 11 2.45a5.327 5.327 0 0 0-3.12 9.648l-.025.01a8 8 0 0 0-2.568 1.732 8.07 8.07 0 0 0-2.365 5.535.172.172 0 0 0 .172.176h1.289c.094 0 .17-.075.172-.168a6.405 6.405 0 0 1 1.886-4.39A6.403 6.403 0 0 1 11 13.106c1.723 0 3.34.67 4.559 1.889a6.406 6.406 0 0 1 1.886 4.39.17.17 0 0 0 .172.167h1.29a.172.172 0 0 0 .171-.176 8.006 8.006 0 0 0-.634-2.97ZM11 11.473a3.671 3.671 0 0 1-2.613-1.083 3.671 3.671 0 0 1-1.082-2.613c0-.986.384-1.914 1.082-2.612A3.671 3.671 0 0 1 11 4.082c.986 0 1.914.385 2.613 1.083a3.672 3.672 0 0 1 1.082 2.612c0 .986-.384 1.915-1.082 2.613A3.671 3.671 0 0 1 11 11.473Z"
      fill="#fff"
    />
  </Svg>
);

export default UserIcon;
